module.exports = __webpack_public_path__ + "static/media/backgroundSecundario.76025122.png";